import { render, staticRenderFns } from "./OfferBox.vue?vue&type=template&id=0368a240"
import script from "./OfferBox.vue?vue&type=script&lang=js"
export * from "./OfferBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports